<template>
    <v-container>
        <div>
            <v-flex>
                <v-row>
                    <h1 class="page-title">Options</h1>
                    <v-spacer class="line"></v-spacer>
                    <send-push-message>
                        <v-btn small color="primary" tile depressed>
                            <v-icon left>mdi-cellphone-message</v-icon>
                            Send Push Message
                        </v-btn>
                    </send-push-message>
                    <hr>
                </v-row>
            </v-flex>

            <v-simple-table v-if="optionsSearched.length !==0">
                <thead>
                <tr>
                    <th class="text-left">Key </th>
                    <th class="text-left">Value</th>
                    <th class="text-left">Description</th>
                    <th class="text-left"></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="option of optionsSearched" :key="option.id">
                        <td>
                            <span class="option-name">{{ option.okey }}</span>
                        </td>
                        <td>
                            <span class="option-name">{{ option.ovalue }}</span>
                        </td>
                        <td>
                            -
                        </td>
                        <td>
                            <span v-if="option.okey == 'map_center_default'">
                                <edit-option-map-modal :thisOptionData="option"></edit-option-map-modal>
                            </span>
                            <span v-else>
                                <edit-option-modal :thisOptionData="option"></edit-option-modal>
                            </span>
                        </td>
                </tr>
                </tbody>
            </v-simple-table>
        </div>
    </v-container>
</template>

<script>
    // import Vue from 'vue'
    import {mapGetters} from 'vuex'
    import SendPushMessage from './SendPushMessage'
    // import * as _ from 'lodash'

    export default {
        name: "Options",
        components: {
            'send-push-message': SendPushMessage
        },
        data: () => ({
            localLoading: false,
            // --
        }),
        mounted(){
            this.$store.dispatch('fetchOptions')
        },
        created()
        {
            // --
        },
        computed: {
            ...mapGetters([
                'options'
            ]),
            optionsSearched() {
                let result = this.options;
                
                return result;
            },
        },
        methods: {
            
        },
    }
</script>

<style scoped>
</style>
